<template>
	<div class="card user-profile">
		<div class="card-body">
			<div class="user-profile-header" v-if="!loading">
				<div class="user-profile-photo">
					<img v-if="profilephoto.url !== ''" :src="profilephoto.url" class="image-round" />
					<div v-if="profilephoto.url === ''" v-bind:style="{backgroundColor: color}" class="image-round  user-profile-photo__default"><span>{{ text }}</span></div>
				</div>
				<div class="user-profile-photo-uploader mt-3" v-if="id === $store.state.user.id">
					<input type="file" ref="file" :accept="profilephoto.accept" :multiple="false" @change="onFileUpload" >
					<b-button size="sm" v-if="!profilephoto.loading" @click="$refs.file.click()" variant="primary">Обновить фотографию</b-button>
					<div class="progress" v-if="profilephoto.loading">
						<div class="progress-bar bg-primary" role="progressbar" :style="{width: profilephoto.percent}" aria-valuemin="0" aria-valuemax="100"></div>
					</div>
				</div>
				<div class="user-profile-name mt-4 h4">{{ user.first_name }} {{ user.last_name }}</div>
			</div>
		</div>
	</div>
</template>
<script>
import stringtohexcolor from '@bezlepkin/stringtohexcolor'
import userHTTP from '@/api/modules/user/user'
export default {
	data () {
		return {
			loading: true,
			id: null,
			user: {},
			color: '',
			text: '',
			profilephoto: {
				percent: 0,
				accept: 'image/jpeg,image/png,image/gif',
				loading: false,
				url: ''
			}
		}
	},
	created () {
		this.prepareUser()
	},
	methods: {
		prepareUser () {
			this.id = parseInt(this.$route.params.id)
			this.loading = true
			userHTTP.findOne(this.id, {expand: 'photo'}).then((user) => {
				const color = stringtohexcolor(user.first_name + ' ' + user.last_name)
				this.color = '#' + color.color
				this.text = color.string
				this.user = user
				if (user.photo !== null) {
					this.profilephoto.url = user.photo.sm
				}
				this.loading = false
				this.setTitle()
			})
		},
		setTitle () {
			document.title = this.user.first_name + ' ' + this.user.last_name
		},
		onFileUpload () {
			const file = this.$refs.file.files[0]
			let formData = new FormData()
			formData.append('file', file)

			this.profilephoto.loading = true
			this.$http.post(this.$store.state.apiURL + '/v1/user/profile/photos', formData, {
				headers: {'Content-Type': 'multipart/form-data'},
				uploadProgress: (e) => {
					this.profilephoto.percent = (e.loaded / e.total) * 100
				}
			}).then((response) => {
				this.prepareUser()
				this.profilephoto.loading = false
			}, (response) => {
				this.profilephoto.loading = false
			})
		}
	},
	watch: {
		'$route': 'prepareUser'
	}
}
</script>
<style lang="scss">
.user-profile {
	min-height: 400px;
	.user-profile-header {
		display: flex;
    align-items: center;
    justify-content: center;
		flex-direction: column;
		padding: 1rem;
	}
	.user-profile-photo {
		width: 100px;
		height: 100px;
		img {
			width: 100%;
			height: auto;
		}
		.user-profile-photo__default {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 100% !important;
			height: 100%;
			color: #fff;
			text-transform: uppercase;
			font-size: 3.5em;
		}
	}
	.user-profile-photo-uploader {
		width: 100%;
		width: 150px;
		button {
			width: 100%;;
		}
		input {
			display: none;
		}
	}
	.user-profile-name {
		font-weight: 500;
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/user/view.vue